import DOMPurify from 'dompurify';

export class BrowserSecurityService {
  public constructor() { }

  public StartupControl = (): boolean => {
    return false;
  };

  public PageChangeControl = (): boolean => {
    return false;
  };

  public SanitizeInnerHtml = (input: string): string => {
    return DOMPurify.sanitize(input);
  };

  public AddURLSafeParams = (params: { name: string, value: any }[]): string => {
    if (params?.length && params?.length > 0) {
      return `${params.map((p) => `${encodeURIComponent(p.name)}=${encodeURIComponent(p.value)}`).join('&')}`;
    } else {
      return '';
    }
  }

  public URLSafeParams = (params: { name: string, value: any }[]): string => {
    if (params?.length && params?.length > 0) {
      return `?${this.AddURLSafeParams(params)}`;
    } else {
      return '';
    }
  };
}
